namespace Matrix.Rebalancer {
    export interface PluginRow {
        PluginName?: string;
        ProgrammingLanguage?: string;
        SourceCode?: string;
        ClassName?: string;
        TypeCode?: string;
        Description?: string;
        SupportedLang?: SupportedLanguage;
        PluginEnabled?: boolean;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
    }

    export namespace PluginRow {
        export const idProperty = 'RowId';
        export const nameProperty = 'PluginName';
        export const localTextPrefix = 'Rebalancer.Plugin';
        export const deletePermission = 'DataAdmin:Rebalancer';
        export const insertPermission = 'DataAdmin:Rebalancer';
        export const readPermission = 'Read:Rebalancer';
        export const updatePermission = 'DataAdmin:Rebalancer';

        export declare const enum Fields {
            PluginName = "PluginName",
            ProgrammingLanguage = "ProgrammingLanguage",
            SourceCode = "SourceCode",
            ClassName = "ClassName",
            TypeCode = "TypeCode",
            Description = "Description",
            SupportedLang = "SupportedLang",
            PluginEnabled = "PluginEnabled",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen"
        }
    }
}
